import routes from "./routes";
import CatProjectService from "./Service";

export {
  routes,
  CatProjectService
};
